<template>
  <div class="deviceManage" ref="deviceManage" @click="clickFuc">
    <div class="home_time" v-if="styleType == 'typeDark'">{{ time }}</div>
    <div class="title_name">
      <div class="allCount">总数（台）</div>
      <div class="onlineCount" v-if="customerId != 96">运行/在线（台）</div>
      <div class="onlineCount" v-else>运行（台）</div>
    </div>
    <div class="tableText">
      <div class="line_text">
        <div class="pat" style="color:rgba(153, 245, 255, 1);font-size:16px">生产设备</div>
        <div class="pat number yellow">{{ dataList.production.allCount }}</div>
        <div class="pat number green">{{ dataList.production.onlinrCount }}</div>
        <div class="tip">运行</div>
      </div>
      <div class="line_text">
        <div class="pat" style="color:rgba(244, 196, 143, 1);font-size:16px">治理设备</div>
        <div class="pat number yellow">{{ dataList.government.allCount }}</div>
        <div class="pat number green">{{ dataList.government.onlinrCount }}</div>
        <div class="tip">运行</div>
      </div>
      <div class="line_text">
        <div class="pat" style="color:rgba(205, 255, 217, 1);font-size:16px">监测设备</div>
        <div class="pat number yellow">{{ dataList.monitor.allCount }}</div>
        <div class="pat number green">{{ dataList.monitor.onlinrCount }}</div>
        <div class="tip">在线</div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '@/utils/tools.js'
import { mapState, mapGetters } from 'vuex'
import deviceManageDialog from './components/deviceManageDialog'
import mybus from "@/utils/eventbus";
export default {
  //import引入的组件需要注入到对象中才能使用
  props: ['matrix', 'x', 'y'],
  data() {
    //这里存放数据
    return {
      pageInfo: 'deviceManage.vue',
      computedName: '全厂设备管理组件',
      styleType: '',
      customerId: this.$store.state.customerId,
      time: dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
      timer: null,
      timeTimer: null,
      dataList: {
        production: {
          allCount: 0,
          onlinrCount: 0
        },
        government: {
          allCount: 0,
          onlinrCount: 0
        },
        monitor: {
          allCount: 0,
          onlinrCount: 0
        }
      }
    }
  },
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      dialogCompontent: 'getDialogCompontent',
      dialogCompontent2: 'getDialogCompontent2'
    }),
    curStyleTypeVal() {
      return this.$store.state.styleType
    }
  },
  //监控data中的数据变化
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal
      },
      deep: true
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = this.$store.state.styleType
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this
    let w = $(that.$refs.deviceManage).outerWidth()
    let h = $(that.$refs.deviceManage).outerHeight()
    that.$emit('componentInit', {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y
    })

    this.getData();
    mybus.$on('showAllEquipment',(value) =>{
      if(value === true) {
        this.clickFuc()
      }
    });
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    if (this.timeTimer) {
      clearInterval(this.timeTimer)
      this.timeTimer = null
    }
  },
  //方法集合
  methods: {
    /**
     * @Description: 全局异常捕获上传
     * @param {String} msg 报错信息
     * @param {Object} instance 报错组件
     * @return void
     * @author liqiuyu
     * @date 2024/3/12
     */
    requestExceptCap(msg, instance) {
      const date = new Date();
      const time = dateFormat('YYYY-mm-dd HH:MM:SS',date);
      const url = this.$apiOpt.platformCollect;

      const param = {
        firstLevelCode: 'notOpen',
        secondLevelCode: 'beforeError',
        additionalInfo: {
          source: 'screen',
          mac: '867788sjgdjbsd',
          customerId: window.bmeConfig.customerSign,
          sourceFile: instance,
          sourcePage: instance,
          time: time,
          msg: ''
        }
      }
      this.$apiUtils.post(url,param).then(res => {

      }).catch(error => {

      });
    },
    async getData() {
      let _this = this

      if (this.timer || this.timeTimer) {
        clearTimeout(this.timer)
        clearInterval(this.timeTimer)
        this.timer = null
        this.timeTimer = null
      }

      this.timeTimer = setInterval(() => {
        _this.time = dateFormat('YYYY-mm-dd HH:MM', new Date())
      }, 1000 * 10)

      let findDeviceAdministration = CONFIG.requestName + this.$apiOpt.findDeviceAdministration
      let data = await _this.$apiUtils.get(findDeviceAdministration, {
        customerId: _this.customerId
      })
      let obj = {
        production: {
          allCount: 0,
          onlinrCount: 0
        },
        government: {
          allCount: 0,
          onlinrCount: 0
        },
        monitor: {
          allCount: 0,
          onlinrCount: 0
        }
      }
      data &&
        data.forEach(v => {
          if (v.primary_type_name == '生产设备') {
            obj.production.allCount = v.count
            obj.production.onlinrCount = v.onLine
          } else if (v.primary_type_name == '治理设备') {
            obj.government.allCount = v.count
            obj.government.onlinrCount = v.onLine
          } else if (v.primary_type_name == '监测设备') {
            obj.monitor.allCount = v.count
            obj.monitor.onlinrCount = v.onLine
          }
        })
      this.dataList = obj
      this.timer = setTimeout(() => {
        this.getData()
      }, 1000 * 60 * 5)
    },
    clickFuc() {
      this.$store.commit('dialogStatus', true)
      this.pageTitleName = '全厂设备管理'
      this.$popup.open(deviceManageDialog, this.dialogCompontent, this, {
        production: this.dataList.production.allCount,
        government: this.dataList.government.allCount,
        monitor: this.dataList.monitor.allCount
      })
    }
  }
}
</script>
<style lang='scss' scoped='scoped'>
.deviceManage {
  width: 600px;
  height: 250px;
  cursor: pointer;

  .title_name {
    display: flex;
    margin-top: 44px;
    justify-content: flex-end;

    .allCount {
      margin-right: 87px;
      font-size: 16px;
      color: #99f5ff;
    }

    .onlineCount {
      margin-right: 34px;
      font-size: 16px;
      color: #99f5ff;
    }
  }

  .tableText {
    @include bg-box(560px, 135px, 'devicebg.png');
    margin-top: 10px;

    .line_text {
      height: 45px;
      display: flex;
      position: relative;

      .pat {
        width: 33%;
        text-align: center;
        line-height: 45px;
        font-size: 26px;
      }
    }
  }
}
</style>
<style scoped>
.yellow {
  color: rgba(244, 196, 143, 1);
}

.green {
  color: rgba(71, 255, 221, 1);
}

.tip {
  position: absolute;
  top: 18px;
  right: 11px;
  height: 16px;
  font-size: 14px;
  color: #c8d8ff;
  line-height: 16px;
}</style>
